import { Outlet } from 'react-router-dom'

export default () => {
  if (typeof document === 'undefined') {
    return <div />
  }
  return (
    <>
      <Outlet />
    </>
  )
}
